import { render } from "./aio-login-days-selector.vue?vue&type=template&id=7327d8b8&scoped=true"
import script from "./aio-login-days-selector.vue?vue&type=script&lang=js"
export * from "./aio-login-days-selector.vue?vue&type=script&lang=js"

import "./aio-login-days-selector.vue?vue&type=style&index=0&id=7327d8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7327d8b8"]])

export default __exports__